import { Button, Icon } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { motion } from 'framer-motion';
import { useFormContext } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import _ from '@lodash';
import { useEditForm } from 'modules/ui/editform/EditFormProvider';

function RegistrationFormToolbar(props) {
	const { setSaveBtnKeyClick } = useEditForm();
	const methods = useFormContext();
	const theme = useTheme();
	const history = useHistory();

	return (
		<div className="flex flex-1 w-full items-center justify-between">
			<motion.div className="flex" initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0, transition: { delay: 0.3 } }}>
				{props.config.otherSaveButtonList
					? props.config.otherSaveButtonList.map(btn =>
							btn.place === 'before' ? (
								<Button
									key={btn.key}
									className="whitespace-nowrap mx-4"
									variant="contained"
									color="secondary"
									onClick={() => setSaveBtnKeyClick({ btnKey: btn.key })}
									startIcon={<Icon className="hidden sm:flex">{btn.icon}</Icon>}
								>
									{btn.text}
								</Button>
							) : null
					  )
					: null}
				<Button className="whitespace-nowrap mx-4" variant="contained" color="secondary" onClick={() => setSaveBtnKeyClick({ btnKey: 'default' })} startIcon={<Icon className="hidden sm:flex">save</Icon>}>
					Registration
				</Button>
				{props.config.otherSaveButtonList
					? props.config.otherSaveButtonList.map(btn =>
							btn.place === 'after' ? (
								<Button
									key={btn.key}
									className="whitespace-nowrap mx-4"
									variant="contained"
									color="secondary"
									onClick={() => setSaveBtnKeyClick({ btnKey: btn.key })}
									startIcon={<Icon className="hidden sm:flex">{btn.icon}</Icon>}
								>
									{btn.text}
								</Button>
							) : null
					  )
					: null}
			</motion.div>
		</div>
	);
}

export default RegistrationFormToolbar;
